import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {Request} from '@simpli/serialized-request'
import {BlockchainVersion} from '@/model/resource/BlockchainVersion'

export class OrbitRound implements IResource {
  idOrbitRoundPk: number = 0

  /** Round numbers restart per network, so a round only means something with it. */
  blockchainVersion: BlockchainVersion | null = null

  round: number | null = null
  transactionHash: string | null = null
  isRunning: boolean | null = null
  /** Contract StartTime when synced; chain “now” when starting a round from the app. */
  startsAt: Date | null = null
  endsAt: Date | null = null
  claimEndsAt: Date | null = null
  distributionEndsAt: Date | null = null
  finishedAt: Date | null = null
  createdAt: Date | null = null

  get $id() {
    return this.idOrbitRoundPk
  }

  set $id(val) {
    this.idOrbitRoundPk = val
  }

  get $tag() {
    return String(this.idOrbitRoundPk)
  }

  /**
   * Persists a new instance of OrbitProject. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistOrbitRound() {
    return await Request.post(`/client/orbit-round`, this)
      .name('persistOrbitRound')
      .asNumber()
      .getData()
  }

  /**
   * Sets the rounds of `networkIdentifier` isRunning to false — every network's
   * when omitted, which is almost never what a round-ending flow wants.
   */
  static async setAllRoundsNotRunning(networkIdentifier?: string | null) {
    return await Request.post(
      `/client/orbit-round/set-all-not-running`,
      undefined,
      {params: networkIdentifier ? {networkIdentifier} : {}}
    )
      .name('setAllRoundsNotRunning')
      .asNumber()
      .getData()
  }
}
